/**
 * Get the API base URL at runtime.
 * 
 * On the preview environment, REACT_APP_BACKEND_URL is set and used directly.
 * On the deployed/custom domain, if the baked-in URL doesn't match the current hostname,
 * we use relative URLs (empty string) so requests go to the same domain.
 * This avoids cross-origin cookie issues when using custom domains.
 */
export function getApiUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL || '';
  
  // If no URL configured, use relative
  if (!envUrl) return '';
  
  // If we're running on the same host as the configured URL, use it
  try {
    const configuredHost = new URL(envUrl).hostname;
    if (window.location.hostname === configuredHost) {
      return envUrl;
    }
  } catch {
    return envUrl;
  }
  
  // Different domain (custom domain like grade9ready.com) — use relative URLs
  return '';
}

const API_URL = getApiUrl();
export default API_URL;
